import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { Router } from '@angular/router';
import { QuizServiceService } from '../../shared/services/quiz-service.service';
import { Observable, of, Subscription, timer } from 'rxjs';
import { AutoLogout } from '../../models/globals';
import { GlobalService } from 'src/app/shared/services/global.service';
import { AdminService } from 'src/app/shared/services/admin.service';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import { demo_variables } from 'src/app/models/demo_global';
import { Clipboard } from '@angular/cdk/clipboard';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SelfAssessmentStateService } from 'src/app/shared/services/self-assessment-state.service';

@Component({
  selector: 'app-self-assessments',
  templateUrl: './self-assessments.component.html',
  styleUrls: ['./self-assessments.component.scss']
})
export class SelfAssessmentsComponent implements OnInit, OnDestroy {

  modeModel = false;
  tutorMode = true;
  timeMode = true;
  quizSuspended = -1;
  QuizId: any;
  quizTitle: any;
  Questionsforquiz: any;


  subscriptions: Subscription[] = [];
  prevTestData: any;
  tests!: any[];
  totalRecords!: number;
  cols!: any[];
  assesmentsList = []
  loading!: boolean;
  representatives!: any[];
  NumofRows: any[] = [
    {numOfRows: 5},
    {numOfRows: 10},
    {numOfRows: 15},
    {numOfRows: 20},
    {numOfRows: 25}
  ];
  selectAssessment:any;

  currentDate  = new Date();
  selectedNum = 5;
  selectedNumOption = this.NumofRows[0];
  duplicateSelectedNum = 5;
  pastPage: any;
  UserName = "Ali Asghar";
  prevQuizData: any;
  subjects: any;
  loader = true;
  quizloader = false;
  quizScore: any;
  innerWidth: any;
  demo = localStorage.getItem('Id')
  isDemo = false;
  editTitle = false;

  displayCopy = false;
  quizId = 0;
  userMembership = false;
  deleteModal = false;
  deleteQuizId = null;
  status = ['All', 'Suspended', 'Completed'];
  selectedStatus = 'All';
  tempPrevTestData: any = [];
  courses: any = [];
  selectedCourse = null;

  TestMode: any[] = [{name: 'Tutor Mode', key: true}, {name: 'Exam Mode', key: false}]
  selectedMode: any;

  // New properties for quiz completion popup
  showNewTestModal = false;
  nextAvailableQuizId: any = null;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 750) {
      const element = document.getElementById('eup-navbar-heading');
      if (element) {
        element.innerText = '';
      }
    }
  }

  constructor(
    private errorHandler: ErrorHandlerService,
    private adminService: AdminService,
    private globalService: GlobalService,
    private router: Router,
    private quizService: QuizServiceService,
    private clipboard: Clipboard,
    private authService: AuthService,
    private selfAssessmentStateService: SelfAssessmentStateService
  ) {
    document.addEventListener('contextmenu', this.removeMouseOptions);
    document.onkeydown = function(e: KeyboardEvent) {
      if(e.keyCode === 123) {
        return false;
      }
      if(e.ctrlKey && e.key === 'E'){
        return false;
      }
      if(e.ctrlKey && e.shiftKey && e.key === 'I'){
        return false;
      }
      if(e.ctrlKey && e.shiftKey && e.key === 'J'){
        return false;
      }
      if(e.ctrlKey && e.key === 'U'){
        return false;
      }
      if(e.ctrlKey && e.key === 'S'){
        return false;
      }
      if(e.ctrlKey && e.key === 'H'){
        return false;
      }
      if(e.ctrlKey && e.key === 'A'){
        return false;
      }
      if(e.ctrlKey && e.key === 'F'){
        return false;
      }
      if(e.ctrlKey && e.key === 'E'){
        return false;
      }
      return true;
    }
  }

  ngOnDestroy(): void {
    // Save state before component is destroyed
    this.saveComponentState();
    
    this.subscriptions.forEach(item => item.unsubscribe());
    document.removeEventListener('contextmenu', this.removeMouseOptions);
    document.onkeydown = null;
  }

  removeMouseOptions(e: Event) { e.preventDefault() }

  async ngOnInit(){
    this.selectedMode = this.TestMode[1]
    this.courses = JSON.parse(localStorage.getItem('subscriptions'))
    
    // Restore saved state from local storage
    this.restoreComponentState();
    
    if (this.courses) {
      if (this.courses.length > 0) {
        // Only set default course if no saved state exists
        if (!this.selectedCourse) {
          this.selectedCourse = this.courses[0].courseID
        }

        if (sessionStorage.getItem('userSelectedCourse')) {
          const courseId = this.courses.find((item: any) => item.courseName == sessionStorage.getItem('userSelectedCourse')).courseID
          this.selectedCourse = courseId;
        }
      }
    }

    this.getUserSubscription()

   await this.getAllAssesments();
   
 
   // Check if user completed a quiz from self-assessments
 
   
    this.globalService.tawkIO(localStorage.getItem('UserName'), localStorage.getItem('email'))
    this.innerWidth = window.innerWidth;
    if(this.innerWidth>750){
      document.getElementById('eup-navbar-heading').innerText = 'Previous Tests';
    }else{
      document.getElementById('eup-navbar-heading').innerText = '';
    }

    let data = {
      userId: localStorage.getItem("Id"),
      assessmentId: 181525
    }
  
    this.loader = false;

    if(localStorage.getItem('Id')=='-1'){
      localStorage.setItem('prevQuizData',JSON.stringify(demo_variables.previouTestData))
      this.isDemo = true
    }
    // if(localStorage.getItem("prevQuizData")){
    //   this.prevQuizData = JSON.parse(localStorage.getItem("prevQuizData"));
    //   this.tempPrevTestData = JSON.parse(JSON.stringify(this.prevQuizData));
    //   this.loader = false;
    //   this.quizloader = false;
    // }else{
  
    
    // }

    this.tests = [
      {name: "Custom Test 1" , score: "50", date: "7 July, 2021", mode: "tutor", status: "completed", subjects: "single",  noofquestions: 3 , ActiveVisiors: 11},
      {name: "Custom Test 2" , score: "40", date: "10 Aug, 2021", mode: "exam", status: "suspended", subjects: "multiple", noofquestions: 4 , ActiveVisiors: 7},
      {name: "Custom Test 3" , score: "70", date: "17 Sep, 2021", mode: "tutor", status: "suspended", subjects: "multiple", noofquestions: 5 , ActiveVisiors: 13},
      {name: "Custom Test 4" , score: "60", date: "27 Jan, 2021", mode: "exam", status: "completed", subjects: "single",  noofquestions: 9 , ActiveVisiors: 15},
      {name: "Custom Test 5" , score: "80", date: "7 July, 2021", mode: "exam", status: "suspended", subjects: "multiple", noofquestions: 4 , ActiveVisiors: 10}
    ];
    this.loading = false;
    this.pastPage = this.tests[0].pastPages;
  }

  selectNum(event: any): void {
    if (event && event.value) {
      this.selectedNum = event.value.numOfRows;
      // Save state when selection changes
      this.selfAssessmentStateService.updateSelectedNum(this.selectedNum);
    }
  }

  async getAllAssesments()
  {
    try {
     
     this.quizloader = true;
      const response: any = await this.quizService.getSelfAssessmentList( this.selectedCourse ).toPromise();
    
      this.assesmentsList = response.data.selfAssessments;
      if (this.assesmentsList.length>0)
      {
        // Check if we have a saved assessment selection that exists in the current list
        const savedState = this.selfAssessmentStateService.getState();
        let hasValidSavedAssessment = false;
        
        if (savedState && savedState.selectAssessment) {
          // Check if the saved assessment exists in the current list
          const savedAssessmentExists = this.assesmentsList.find(
            assessment => assessment.assessment_id === savedState.selectAssessment
          );
          
          if (savedAssessmentExists) {
            this.selectAssessment = savedState.selectAssessment;
            hasValidSavedAssessment = true;
          }
        }
        
        // If no valid saved assessment, use the first one
        if (!hasValidSavedAssessment) {
          this.selectAssessment = this.assesmentsList[0].assessment_id;
        }
        
        console.log(this.selectAssessment ,' asd')
          let data = {
            userId: localStorage.getItem("Id"),
            assessmentId: this.selectAssessment
          }
          await this.getAssessmentquizes(data);
         
      }
      this.quizloader = false;
      
      // Save state after assessment is loaded
      this.saveComponentState();
      
    } catch (error) {
      this.errorHandler.handleError(error);
    }
  }

  loadCustomers(event: LazyLoadEvent) {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  async getAssesmentsQuizes()
  {

    this.quizloader = true;
    let data = {
      userId: localStorage.getItem("Id"),
      assessmentId: this.selectAssessment
    }
    await this.getAssessmentquizes(data)
    
    // Save state when assessment selection changes
    this.selfAssessmentStateService.updateSelectedAssessment(this.selectAssessment);
    // this.quizloader = false;
  }

  gotoPerformanceScreen(i: any, quizId: any, quizTitle: any, quizScore: any, quizStatus: any): void {
    localStorage.setItem("quizStatus", quizStatus);

   
    localStorage.setItem("QuizId", quizId);
    localStorage.setItem("quizTitle", quizTitle);
    if (i === 1) {
      localStorage.setItem("testResult", JSON.stringify(true));
      this.router.navigate(['/dashboard/performancescreen/results']);
    } else {
      localStorage.setItem("testResult", JSON.stringify(false));
      this.router.navigate(['/dashboard/performancescreen/analysis']);
    }
  }

  async getUserSubscription() {
    if (localStorage.getItem('Id') !== '-1') {
      try {
        const response: any = await this.authService.getUserSubscription().toPromise();
        this.userMembership = response?.status || false;
      } catch (error) {
        this.errorHandler.handleError(error);
      }
    }
  }

  resumeQuiz(quiz_id: any, quizScore: any): any {
    this.quizScore = quizScore;
    if (localStorage.getItem('Id') != '-1') {
      this.loader = true;
      let viewMode = true;
      
      // Set flag to indicate quiz was resumed from self-assessments
      localStorage.setItem("quizOrigin", "self-assessments");
      localStorage.setItem("selfAssessmentId", this.selectAssessment);
      
      this.subscriptions.push(
        this.quizService.resumePrevQuizzes(quiz_id, viewMode).subscribe((res: any) => {
          var quizScore;
          var quizTitle;
          var quizMode;
          var quiz_time;
          var quizId;
          var isTimed = false;
          var currentIndexId = 0;

          var allQuestions = [];
          var submittedQuestions = [];
          var flaggedQuestions = [];
          var notes = [{ note: 'dummy data', questionId: -1 }];

          quizScore = res.data?.previousQuizzes[0]?.quiz_meta?.quizScore;
          quizTitle = res.data?.previousQuizzes[0]?.quiz_meta?.quizTitle;
          quizMode = res.data?.previousQuizzes[0]?.quiz_meta?.quizMode;
          quiz_time = res.data?.previousQuizzes[0]?.quiz_meta?.quizTime;
          quizId = res.data?.previousQuizzes[0]?.quiz_meta?.quizId;
          isTimed = res.data?.previousQuizzes[0]?.quiz_meta?.isTimed;
          currentIndexId = res.data?.previousQuizzes[0]?.quiz_meta?.currentIndex;

          for (let i = 0; i < res.data?.questions?.length; i++) {
            // Getting Flagged Questions
            if (res.data?.questions[i].marked != -1) {
              flaggedQuestions.push({ QuestionId: res.data?.questions[i]?.marked, index: i });
            }

            // Getting already submitted Questions
            if (res.data?.questions[i]?.submitData && res.data?.questions[i]?.submitData != null) {
              submittedQuestions.push(JSON.parse(res.data?.questions[i]?.submitData));
            }

            // Getting Notes
            if (res.data?.questions[i]?.notes && res.data?.questions[i]?.notes != null) {
              notes.push({ note: res.data?.questions[i]?.notes, questionId: res.data?.questions[i]?.post_id });
            }

            // getting all Questions that have options
            if (res.data?.questions[i]?.options.length > 0) {
              allQuestions.push({
                answer_data: res.data?.questions[i]?.answer_data,
                answer_type: res.data?.questions[i]?.answer_type,
                correct_msg: res.data?.questions[i]?.correct_msg,
                id: res.data?.questions[i]?.id,
                incorrect_msg: res.data?.questions[i]?.incorrect_msg,
                ld_Correct_Percentage: res.data?.questions[i]?.ld_Correct_Percentage,
                ld_hits_details: res.data?.questions[i]?.ld_hits_details,
                options: res.data?.questions[i]?.options,
                postId: res.data?.questions[i]?.post_id,
                quiz_id: res.data?.questions[i]?.quiz_id,
                statistics: res.data?.questions[i]?.statistics,
                subjects: res.data?.questions[i]?.subjects,
                systems: res.data?.questions[i]?.systems,
                topics: res.data?.questions[i]?.topics,
                question: res.data?.questions[i]?.question,
                linked: res.data?.questions[i].linked,
                priority: res.data?.questions[i].priority,
                UWorldID: res.data?.questions[i]?.UWorldID,
                questionTime: res.data?.questions[i].submitData ? JSON.parse(res.data?.questions[i].submitData).time : 0,
                totalLinks: res.data?.questions[i].totalLinks
              });
            }
          }

          localStorage.setItem("AllQuestions", JSON.stringify(allQuestions));
          localStorage.setItem("quizScore", res.data.previousQuizzes[0].quiz_meta.quizScore);
          localStorage.setItem("SubmittedQuestions", JSON.stringify(submittedQuestions));
          localStorage.setItem("NotesArray", JSON.stringify(notes));
          localStorage.setItem("quizTitle", quizTitle);
          localStorage.setItem("QuizMode", quizMode);
          localStorage.setItem("quiz_time", quiz_time);
          localStorage.setItem("QuizId", quizId);
          localStorage.setItem("isTimed", JSON.stringify(isTimed));
          localStorage.setItem("isResumed", JSON.stringify(1));
          localStorage.setItem("viewMode", JSON.stringify(false));
          localStorage.setItem("currentIndexId", JSON.stringify(currentIndexId));
          localStorage.setItem("flaggedQuestion", JSON.stringify(flaggedQuestions));

          const arr = ['qbankStatistics', 'subjectStatistics', 'systemStatistics', 'topicStatistics'];
          arr.forEach(i => {
            localStorage.removeItem(i);
          });
          localStorage.setItem("quizCompletedFromSelfAssessment", "true")
          this.router.navigate(['/quiz']);
          this.loader = false;
        },
        (err: any) => {
          AutoLogout(err);
        })
      );
    } else {
      localStorage.setItem("AllQuestions", JSON.stringify(demo_variables.allQuestions));
      localStorage.setItem("quizScore", '0');
      localStorage.setItem('SubmittedQuestions', JSON.stringify(demo_variables.SubmittedQuestions));
      localStorage.setItem("NotesArray", JSON.stringify([]));
      localStorage.setItem("quizTitle", 'Demo Quiz');
      localStorage.setItem("QuizMode", 'tutor');
      localStorage.setItem("QuizId", '-1');
      localStorage.setItem("isTimed", JSON.stringify(false));
      localStorage.setItem("isResumed", JSON.stringify(1));
      localStorage.setItem("viewMode", JSON.stringify(false));
      localStorage.setItem("flaggedQuestion", JSON.stringify([]));

      const arr = ['qbankStatistics', 'subjectStatistics', 'systemStatistics', 'topicStatistics'];
      arr.forEach(i => {
        localStorage.removeItem(i);
      });
      localStorage.setItem("quizCompletedFromSelfAssessment", "true")
      this.router.navigate(['/quiz']);
    }
  }

  selectTitle(quiz: any) {
    this.editTitle = true;
    this.quizId = quiz.quiz_id;
    this.quizTitle = quiz.quiz_meta.quizTitle;
  }

  copyText(textToCopy: string) {
    this.clipboard.copy(textToCopy);
    this.displayCopy = true;
    setTimeout(() => {
      this.displayCopy = false;
    }, 1500);
  }

  selectQuiz(quizId: any) {
    this.deleteModal = true;
    this.deleteQuizId = quizId;
  }

  async deleteQuiz() {
    try {
      await this.quizService.deleteQuiz(this.deleteQuizId).toPromise();
      this.deleteModal = false;
      await this.getSelfAssessments({ userId: localStorage.getItem("Id"), courseId: this.selectedCourse });
    } catch (error) {
      this.errorHandler.handleError(error);
    }
  }

  async getAssessmentquizes(data: any) {
    await this.subscriptions.push(
      this.quizService.getSelfAssessmentQuizes(data).subscribe((res: any) => {
        // Apply sequential visibility logic
        let foundFirstIncomplete = false;
        
        // Sort quizzes by their order if needed
        const quizzes = res.data.quizzes;
        
        // Apply visibility rules
        for (let quiz of quizzes) {
          if (quiz.quiz_meta.quizStatus === 'completed') {
            // Completed quizzes are always visible
            quiz.quiz_meta['visibility'] = true;
          } else if (!foundFirstIncomplete) {
            // First incomplete quiz found - make it visible
            quiz.quiz_meta['visibility'] = true;
            foundFirstIncomplete = true;
          } else {
            // All subsequent incomplete quizzes should be hidden
            quiz.quiz_meta['visibility'] = false;
          }
        }

        this.prevQuizData = quizzes;
        console.log('asdaasd',this.prevQuizData)
        this.tempPrevTestData = JSON.parse(JSON.stringify(this.prevQuizData));

        for (let item of this.prevQuizData) {
          item.quiz_meta.quizTotalTime = this.convertSecondsToTime(item.quiz_meta.quizTotalTime);
          item.quiz_meta.quizTimeRemaining = this.convertSecondsToTime(item.quiz_meta.quizTimeRemaining);
        }

        this.checkForQuizCompletion();

        this.quizloader = false;
      },
      (err: any) => {
        AutoLogout(err);
      })
    );
  }

  async editQuizTitle(quiz: any) {
    let data = {
      "quizId": quiz.quiz_id,
      "userId": localStorage.getItem('Id'),
      "title": this.quizTitle
    }
    try {
      await this.quizService.editQuizTitle(data).toPromise();
      this.editTitle = false;
      await this.getSelfAssessments({ userId: localStorage.getItem("Id"), courseId: this.selectedCourse });
    } catch (error) {
      this.errorHandler.handleError(error);
    }
  }

  filterByStatus() {
    if (this.selectedStatus === 'All') {
      this.prevQuizData = JSON.parse(JSON.stringify(this.tempPrevTestData));
    } else {
      this.prevQuizData = this.tempPrevTestData.filter(quiz => quiz.quiz_meta.quizStatus === this.selectedStatus.toLowerCase());
    }
    
    // Save state when status filter changes
    this.selfAssessmentStateService.updateSelectedStatus(this.selectedStatus);
  }

  async filterByCourse() {
    // Save state when course selection changes
    this.selfAssessmentStateService.updateSelectedCourse(this.selectedCourse);

    await this.getAllAssesments()
  }

  async getSelfAssessments(data: any) {
    try {
      const response: any = await this.quizService.getPreviousQuizzes(data).toPromise();
      this.prevQuizData = response.quizzes;
      this.tempPrevTestData = JSON.parse(JSON.stringify(this.prevQuizData));
      this.loader = false;
      this.quizloader = false;
    } catch (error) {
      this.errorHandler.handleError(error);
      this.loader = false;
      this.quizloader = false;
    }
  }

  convertSecondsToTime(seconds: number): string {
    if (seconds >= 3600) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      return `${hours}h ${minutes}m`;
    } else {
      const minutes = Math.floor(seconds / 60);
      return `${minutes}m`;
    }
  }

  async resetSelfAssessment(): Promise<void> {
    try {
      this.quizloader = true;
      
      const data = {
        userId: localStorage.getItem("Id"),
        assessmentId: this.selectAssessment
      };

      const response: any = await this.quizService.resetUserSelfAssessment(data).toPromise();
      
      // Refresh the assessment data after reset
      await this.getAllAssesments();
      
      this.quizloader = false;
    } catch (error) {
      this.errorHandler.handleError(error);
      this.quizloader = false;
    }
  }

  getQuiz(quizId: any): void{
    this.tutorMode = this.selectedMode.key;
    (this.tutorMode == true) ? localStorage.setItem("QuizMode", "tutor") : localStorage.setItem("QuizMode", "exam");
    (this.timeMode == true) ? localStorage.setItem("isTimed", JSON.stringify(true)): localStorage.setItem("isTimed", JSON.stringify(false))
    
    // Set flag to indicate quiz was started from self-assessments
    localStorage.setItem("quizOrigin", "self-assessments");
    localStorage.setItem("selfAssessmentId", this.selectAssessment);
    
    this.quizloader = true;
    localStorage.setItem("QuizId", quizId);
    this.quizService.getQuizDetails(quizId).subscribe((res: any) => {
      this.Questionsforquiz = res.data;
      const arr = ['SelectedOptionArray', 'SubmittedQuestions', 'singleQuestionTime', 'currentQuestionIndex', 'CurrentIndex', 'dotQuestionsArray', 'quiz_time', 'timesup', 'AnswerChanges', 'qbankStatistics', 'subjectStatistics', 'systemStatistics', 'topicStatistics'];
      arr.forEach(i => {
        localStorage.removeItem(i);
      });
      localStorage.setItem("AllQuestions",JSON.stringify(this.Questionsforquiz));
      localStorage.setItem("quizCompletedFromSelfAssessment", "true")
      this.router.navigate(['/quiz']);
      this.quizloader = false;
    },
    error => {
      this.errorHandler.handleError(error);
    })
  }

  async checkForQuizCompletion() {
    // Check if user just completed a quiz from self-assessments
    const quizCompleted = localStorage.getItem("quizCompletedFromSelfAssessment");
    
    if (quizCompleted === "true") {
      // Clear the flag
      localStorage.removeItem("quizCompletedFromSelfAssessment");
      
      // Find next available quiz
      this.findNextAvailableQuiz();
      
      // Show popup only if there's a next quiz available
      if (this.nextAvailableQuizId) {
        this.showNewTestModal = true;
      }

      // Navigate to assessment-report page if all the quizzes are completed //
      if (this.prevQuizData.every(quiz => quiz.quiz_meta.quizStatus === 'completed')) {
        this.router.navigate(['/dashboard/assessment-report']);
      }
    }
  }

  findNextAvailableQuiz() {

    console.log('asdsd',this.prevQuizData)

    if (!this.prevQuizData || this.prevQuizData.length === 0) {
      this.nextAvailableQuizId = null;
      return;
    }
console.log('not returning')
    // Find the first quiz that is not completed and is visible (following sequential logic)
    for (let quiz of this.prevQuizData) {
      if (quiz.quiz_meta.visibility && 
          quiz.quiz_meta.quizStatus !== 'completed' && 
          quiz.quiz_meta.quizStatus !== 'suspended') {
        this.nextAvailableQuizId = quiz.quiz_id;
        return;
      }
    }
    
    this.nextAvailableQuizId = null;
  }

  startNextQuiz() {
    if (this.nextAvailableQuizId) {
      localStorage.removeItem("quizCompletedFromSelfAssessment")
      this.showNewTestModal = false;
      this.getQuiz(this.nextAvailableQuizId);
    }
  }

  closeNewTestModal() {

    localStorage.removeItem("quizCompletedFromSelfAssessment")
    this.showNewTestModal = false;
    this.nextAvailableQuizId = null;
  }

  // State Management Methods
  private restoreComponentState(): void {
    const savedState = this.selfAssessmentStateService.getState();
    if (savedState) {
      // Restore selected course
      if (savedState.selectedCourse) {
        this.selectedCourse = savedState.selectedCourse;
      }
      
      // Restore selected assessment
      if (savedState.selectAssessment) {
        this.selectAssessment = savedState.selectAssessment;
      }
      
      // Restore selected status filter
      if (savedState.selectedStatus) {
        this.selectedStatus = savedState.selectedStatus;
      }
      
      // Restore selected number of rows
      if (savedState.selectedNum) {
        this.selectedNum = savedState.selectedNum;
        // Find the corresponding option object
        const numOption = this.NumofRows.find(option => option.numOfRows === savedState.selectedNum);
        if (numOption) {
          this.selectedNumOption = numOption;
        }
      }
    }
  }

  private saveComponentState(): void {
    this.selfAssessmentStateService.saveState({
      selectedCourse: this.selectedCourse,
      selectAssessment: this.selectAssessment,
      selectedStatus: this.selectedStatus,
      selectedNum: this.selectedNum
    });
  }

  // Clear saved state (useful when user logs out or wants to reset)
  public clearComponentState(): void {
    this.selfAssessmentStateService.clearState();
  }
}
